import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Col, Row, Space } from 'antd';
import { useDispatch } from 'react-redux';
import GraasIconSmall from 'assets/images/graas_blue.svg';
import { Helmet } from 'react-helmet';
import { map as _map, isEmpty as _isEmpty } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { isBrowser, isMobile } from 'react-device-detect';
import './AuthWrapper.scss';
import SignupLoginGradient from 'assets/images/signup-login/background-gradient.png';
import parse from 'html-react-parser';
import SecureLogo1 from 'assets/images/aicpa-logo.png';
import SecureLogo2 from 'assets/images/iso-logo.png';
import SecureLogo3 from 'assets/images/GDPR-Logo.svg';
import { imageConfig } from './SliderImageUtility';
import queryString from 'query-string';
import SchneiderImage from 'assets/images/signup-login/brands/brand1.png';
import HaleonImage from 'assets/images/signup-login/brands/brand2.png';
import UnileverImage from 'assets/images/signup-login/brands/brand3.png';
import OmronImage from 'assets/images/signup-login/brands/brand4.png';
import PumaImage from 'assets/images/signup-login/brands/brand5.png';
import PulaChoiceImage from 'assets/images/signup-login/brands/brand6.png';
import AuthorImage from 'assets/images/signup-login/testimonial-author.png';
import quotesImage from 'assets/images/signup-login/quotes.png';
import { useLocation } from 'react-router-dom';
const LanguageSelection = lazy(() => import(/* webpackChunkName: 'LanguageSelection' */ 'pages/LanguageSelection'));
const brands = [
  { name: 'Puma', logo: PumaImage },
  { name: 'Unilever', logo: UnileverImage },
  { name: 'Pula Choice', logo: PulaChoiceImage },
  { name: 'Schneider', logo: SchneiderImage },
  { name: 'Omron', logo: OmronImage },
  { name: 'Haleon', logo: HaleonImage }
];

// Dynamic image loading function
const loadCountryImage = async (languageCode, detectedCountry) => {
  try {
    if (detectedCountry === 'IN') {
      switch (languageCode) {
        case 'th_TH':
          return (await import('assets/images/signup-login/data-analytics-india-th.png'))?.default;
        case 'in_ID':
          return (await import('assets/images/signup-login/data-analytics-india-id.png'))?.default;
        case 'en_US':
        default:
          return (await import('assets/images/signup-login/data-analytics-india-us.png'))?.default;
      }
    } else {
      switch (languageCode) {
        case 'th_TH':
          return (await import('assets/images/signup-login/data-analytics-th.png'))?.default;
        case 'in_ID':
          return (await import('assets/images/signup-login/data-analytics-id.png'))?.default;
        case 'en_US':
        default:
          return (await import('assets/images/signup-login/data-analytics-us.png'))?.default;
      }
    }
  } catch (error) {
    console.error('Failed to load country image:', error);
    return null;
  }
};

const AuthWrapper = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const languageCode = Cookies.get('locale') || 'en_US';
  const query = queryString.parse(window?.location?.search);
  const location = useLocation();
  const isLoginPage = location.pathname.includes('/login');
  const isDemoPage = location.pathname.includes('/demo');
  const isForgotPasswordPage = location.pathname.includes('/forgotPassword');
  const isFirstStep = query?.action === 'primary';
  const isSecondStep = query?.action === 'otp_verification';
  const isThirdStep = query?.action === 'create_password';
  const [detectedCountry, setDetectedCountry] = useState('');
  // State to store the dynamically loaded image
  const [countryImage, setCountryImage] = useState(null);
  const [isLoadingImage, setIsLoadingImage] = useState(false);

  // Load the image based on language code
  useEffect(() => {
    if ((isThirdStep || isLoginPage || isForgotPasswordPage || isDemoPage) && !_isEmpty(detectedCountry)) {
      setIsLoadingImage(true);
      loadCountryImage(languageCode, detectedCountry)
        .then(image => {
          setCountryImage(image);
          setIsLoadingImage(false);
        })
        .catch(() => {
          setIsLoadingImage(false);
        });
    }
  }, [isThirdStep, isLoginPage, isForgotPasswordPage, detectedCountry ,isDemoPage]);

  const detectAndFetchCountryData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_DETECT_COUNTRY_API_HOST;
      if (apiUrl) {
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json; charset=utf-8'
          }
        });

        // Check if the response status is OK (status code 200)
        if (!response.ok) {
          throw new Error(`Fail to get country details`);
        }

        // Parse the response body as JSON
        const result = await response.json();
        setDetectedCountry(result?.country_code);
      } else {
        setDetectedCountry('IN');
        throw new Error(`Fail to get country details`);
      }
    } catch (error) {
      setDetectedCountry('IN');
    }
  };

  useEffect(() => {
    detectAndFetchCountryData();
  }, [dispatch]);

  return (
    <>
      <Helmet>
        {/* {process.env.NODE_ENV === 'production' && (
          <script type='text/javascript'>
            {`
           window._mfq = window._mfq || [];
           (function() {
           var mf = document.createElement("script");
           mf.type = "text/javascript"; mf.defer = true;
           mf.src = "//cdn.mouseflow.com/projects/abec1771-865c-481a-b885-ff5980c3e349.js";
           document.getElementsByTagName("head")[0].appendChild(mf);
            })();
          `}
          </script>
        )} */}
        <script
          id='cookieyes'
          type='text/javascript'
          src='https://cdn-cookieyes.com/client_data/1ca72173baa4607df7a9ab75/script.js'
        ></script>
      </Helmet>

      {/* Login page container */}
      <div
        className={`c-loginPageWrapper ${isMobile ? 'for-mobile' : ''}`}
        style={{
          backgroundImage: !isMobile ? `url(${SignupLoginGradient})` : ''
        }}
      >
        {/* Login page container :: Left section */}
        <div className='container-left'>
          {isMobile && (
            <div className='header'>
              <Row align='middle'>
                <Col md={18} xs={16}>
                  <img src={GraasIconSmall} alt='logo' className='logo' height={42} />
                </Col>
                <Col md={6} xs={8} className='text-right'>
                  <Suspense fallback={<></>}>
                    <LanguageSelection />
                  </Suspense>
                </Col>
              </Row>
            </div>
          )}

          <div className='contentHolder'>
            {!isMobile && (
              <>
                <div className='logo'>
                  <img src={GraasIconSmall} alt='logo' height={42} />
                </div>
                <h1 className='Graas-heading size-1 bold mgb-0 dont-break main-heading'>
                  {parse(t('GRAAS_ALL_YOUR_DATA_ONE_SOURCE_OF_TRUTH_POWERED_FOR_GROWTH_GRAAS'))}
                </h1>
              </>
            )}

            {/* Priority to specific page checks over step checks */}
            {(isThirdStep || isLoginPage || isForgotPasswordPage || isDemoPage) && (
              <div className='data-analytics-cards'>
                {isLoadingImage ? (
                  <div className='image-loading-placeholder'>Loading...</div>
                ) : (
                  countryImage && (
                    <img
                      src={countryImage}
                      alt='data analytics cards'
                      height={!isMobile ? 286 : null}
                      width={!isMobile ? 525 : null}
                      style={!isMobile ? { marginLeft: -22 } : {}}
                    />
                  )
                )}
              </div>
            )}

            {/* Only show brands if it's the first step and not the forgot password page */}
            {isFirstStep && !isForgotPasswordPage && (
              <div className='brandListing'>
                <p className='Graas-heading size-5' style={{ marginBottom: 32 }}>
                  {t('GRAAS_TRUSTED_BY_200PLUS_BRANDS_INCLUDING_GRAAS')}
                </p>
                <div className='brands'>
                  {_map(brands, (item, index) => {
                    return <img key={`brand-${index}`} src={item.logo} alt={item.name} className='brand' />;
                  })}
                </div>
              </div>
            )}

            {/* Only show testimonials if it's the second step and not the forgot password page */}
            {isSecondStep && !isForgotPasswordPage && !isLoginPage && !isThirdStep && !isDemoPage &&(
              <div className='testimonial'>
                <img src={quotesImage} alt='quotes' style={{ position: 'relative', left: -20 }} />
                <h4 className='Graas-heading mgb-3 dont-break'>{t('GRAAS_TESTIMONY_GRAAS')}</h4>
                <Space className='testimonial-author'>
                  <img src={AuthorImage} alt='author' />
                  <div>
                    <span className='Graas-heading size-5 bold'>{t('GRAAS_TESTIMONY_AUTHOR_GRAAS')}</span>
                    <span className='Graas-heading size-5'>{t('GRAAS_TESTIMONY_BRAND_GRAAS')}</span>
                  </div>
                </Space>
              </div>
            )}
          </div>
        </div>
        {/* Login page container :: Left section End */}

        {/* Login page container :: Right section */}
        <div className='container-right'>
          <div className='contentHolder'>
            {props?.children}
            <Row align='middle' className={isMobile ? 'mg-1' : ''}>
              {!isMobile && (
                <Col xs={7}>
                  <Suspense fallback={<></>}>
                    <LanguageSelection />
                  </Suspense>
                </Col>
              )}
              <Col xs={15} md={10} className={isMobile ? 'pdl-3' : 'text-center'}>
                <button
                  className='Graas-button is-link color-light underline pd-0 font-normal dont-break'
                  target='_blank'
                  onClick={() => {
                    window.open('https://www.graas.ai/data-security', '_blank');
                  }}
                >
                  {t('GRAAS_YOUR_DATA_SECURED_AND_CERTIFIED_GRAAS')}
                </button>
              </Col>
              <Col xs={8} md={7} className='text-right'>
                <button
                  className='Graas-button is-link color-light underline pd-0 font-normal'
                  target='_blank'
                  onClick={() => {
                    window.open(`/cookiePolicy`, '_blank');
                  }}
                >
                  {t('GRAAS_COOKIE_POLICY_GRAAS')}
                </button>
              </Col>
            </Row>
            <div className='containerFooter mt-10 text-center'>
              <Space size={16}>
                <img src={SecureLogo2} alt='logo' height={47} />
                <img src={SecureLogo1} alt='logo' height={47} />
                <img src={SecureLogo3} alt='logo' height={47} />
              </Space>
            </div>
          </div>
        </div>
        {/* Login page container :: Right section End */}
      </div>
      {/* Login page container End */}
    </>
  );
};

export default AuthWrapper;
